import React, { useEffect, useState } from "react";
import Auth from "src/auth";

import { apiCallResponse } from "src/_apiConfig/apiCall";
import {
  CommonSearchExtra,
  SCInput,
  updateSearchStatus,
} from "../common/CommonSearch";
import {
  FilterContains,
  FilterContainsInsensitive,
} from "../common/FilterCondition";

import { TableHeader } from "../common/Table/TableHeaderLabel";
import DropDownDisctrict from "../common/controller/DropDown/Disctrict";
import CommonList from "../common/CommonList";

const DfoModule = () => {
  const { authenticated } = Auth();
  const [usersData, setUsersData] = useState(); // List Data Set
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false); // page loading
  const [pageLimit, setpageLimit] = useState(0); // pageing index manage
  const [itemPerPage, setItemPerPage] = useState(10); // Record Show Each Page
  const [disabledprev, setdisabledprev] = useState(false); //Pagging Prev. Button disabled manage
  const [disablednext, setdisablednext] = useState(false); //Pagging Next Button disabled manage

  const [textField, settextField] = useState("emailId");

  const [order, setorder] = useState("asc");
  const [orderClick, setOrderClick] = useState(true);

  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage

  // Your default search model
  const SearchFilterModel = {
    disctrict: "",
    mobile: "",
    emailAddress: "",
    street: "",
  };

  const [search, setSearch] = useState(SearchFilterModel);

  // useEffect(() => {
  //   orderClick ? setorder("asc") : setorder("desc");
  //   getDfolist(true);
  //   getDistrictList(true);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [pageLimit, textField, orderClick, itemPerPage]);

  useEffect(() => {
    setloading(true);
    reset();
    getPageCount();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getDfolist();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit, textField, orderClick]);

  useEffect(() => {
    if (isSearch) {
      getPageCount();
      getDfolist(true);
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  const thClick = (ev, getTextField) => {
    ev.preventDefault();
    setOrderClick(!orderClick);
    if (textField !== getTextField) {
      setorder("asc");
    } else {
      !orderClick ? setorder("asc") : setorder("desc");
    }
    reset();
    settextField(getTextField);
  };
  //table Header Set
  const TableHeaderSet = (labelValue, getTextField) => {
    return TableHeader(labelValue, getTextField, thClick, textField, order);
  };
  // pagging Disabled  manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  // pagging Manage
  const paggingDisabledManage = (totalRecord, isRecordGet = true) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };
  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    reset();
    setIsSearch(true);
  };
  // Clear Button Click Event
  const clearSearchButton = (ev) => {
    ev.preventDefault();
    reset();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModel });
    setUsersData();
  };

  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitSet = parseInt(pageLimit) - parseInt(itemPerPage);
    pageLimitSet = pageLimitSet < 0 ? 0 : pageLimitSet;
    setpageLimit(pageLimitSet);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitSet = parseInt(pageLimit) + parseInt(itemPerPage);
    pageLimitSet =
      pageLimitSet >= parseInt(pageCount) ? parseInt(pageCount) : pageLimitSet;
    setpageLimit(pageLimitSet);
  };

  const reset = () => {
    setpageLimit(0);
  };

  // Filter paramater Value manage for API
  const filterManage = () => {
    let filter = "";
    filter = "&$filter=";
    filter = FilterContains(filter, "districtName", search.disctrict);
    filter = FilterContains(filter, "mobile", search.mobile);
    filter = FilterContainsInsensitive(filter, "emailId", search.emailAddress);
    filter = FilterContainsInsensitive(filter, "streetName", search.street);

    if (filter === "&$filter=") {
      filter = "";
    }
    console.log("filterManage : ", filter);
    return filter;
  };

  const getPageCount = async () => {
    if (authenticated) {
      await apiCallResponse(
        `District_Master/getOfficers?${filterManage()}`
      ).then((res) => {
        if (res.success) paggingDisabledManage(parseInt(res.data.length) || 0);
      });
    }
  };
  const getDfolist = async (firstRequest) => {
    if (authenticated) {
      paggingDisabled();
      setloading(true);

      await apiCallResponse(
        `District_Master/getOfficers?$orderBy=${textField}%20${order}&$skip=${pageLimit}&$top=${Number(
          itemPerPage
        )}${filterManage()}`
      )
        .then((res) => {
          if (res.success) {
            setUsersData(res.data);
            if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
              paggingDisabledManage(pageCount);
            }
          }
        })
        .finally(() => {
          setloading(false);
        });
    }
  };

  const searchControl = (
    <>
      <SCInput
        label={"Email Address :"}
        name={"emailAddress"}
        value={search.emailAddress}
        onChange={updateSearch}
      />
      <DropDownDisctrict
        isClear={isClear}
        isValueLabelSame={true}
        name={"disctrict"}
        value={search.disctrict}
        onChange={updateSearch}
      />
      <SCInput
        label={"Mobile No. :"}
        id={"mobile"}
        name={"mobile"}
        value={search.mobile}
        onChange={updateSearch}
      />

      <SCInput
        label={"Street Location :"}
        id={"street"}
        name={"street"}
        value={search.street}
        onChange={updateSearch}
      />
    </>
  );
  let additional = (
    <CommonSearchExtra
      isDisabledSearchClear={loading}
      extraControl={searchControl}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearchButton={clearSearchButton}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
    />
  );

  const fields = [
    {
      key: "emailId",
      label: TableHeaderSet("Email Address", "emailId"),
    },
    {
      key: "name",
      label: TableHeaderSet("Name", "name"),
    },
    {
      key: "mobile",
      label: TableHeaderSet("Mobile No", "mobile"),
    },
    {
      key: "districtName",
      label: TableHeaderSet("District Union", "districtName"),
    },
    {
      key: "Street",
      label: TableHeaderSet("Street Location", "streetName"),
    },
  ];
  return (
    <CommonList
      items={usersData}
      fields={fields}
      listName="District Union Forest Officer"
      loading={loading}
      path="/dfolist"
      additional={additional}
      prev={prevButton}
      next={nextButton}
      disabledprev={disabledprev}
      disablednext={disablednext}
    />
  );
};
export default DfoModule;
